import React from "react";
import {
  SideNavigationV2Props,
  type CustomComponent,
} from "skedyul-ui/src/components/ui/SideNavigationV2";
import { SideNavigationComponentProps } from "@schemas/sideNavigation.schema";
import { PromoteScenariosSidebarHost } from "@/components/developers/PromoteScenariosSidebarHost";

export const promoteScenariosSidebarSchema = (
  args: SideNavigationComponentProps<CustomComponent, { subdomain: string }>,
): SideNavigationV2Props<CustomComponent> => {
  return {
    side: args.position,
    isOpen: args.state.sideNavigation[args.position].isOpen,
    width: args.width,
    component: {
      component: "Custom",
      props: {
        children: React.createElement(PromoteScenariosSidebarHost),
      },
    },
  };
};
